import React, {useState} from 'react';
import HomeSectionTitle from "../../HomeSectionTitle";
import BubbleArrow from "../../BubbleArrow";
import classnames from "classnames";
import MediaQuery from 'react-responsive';
import "./CashRebate.scss";


const CashRebate = ({sectionTitle, txt, diagram, expandable, size}) => {

	const [expanded, setExpanded] = useState(!expandable);

	return (
		<div className="cash-rebate boxed" id="cash-rebate">
			<div className="row">
				<div
					className="col col-xs-12 col-md-6 cash-rebate__diagram"
					style={{
						maxHeight: expanded ? "2000px" : size + "px",
						transition: "max-height .66s ease-in-out"
					}}
				>
					<img src={diagram} alt={"Diagram: " + sectionTitle}/>
					{expandable &&
						<MediaQuery minWidth={769}>
						<span
							className={classnames("cash-rebate__diagram__trigger", {"rotate": expanded})}
							onClick={() => setExpanded(!expanded)}>
							<BubbleArrow size="44px" animate/>
						</span>
						</MediaQuery>
					}
				</div>
				<div
					className="col col-xs-12  col-md-6 cash-rebate__textbox"
					style={{maxHeight: expandable ? `${size}px` : "auto"}}>
					<div className="row">
						<div className="col col-xs-12 cash-rebate__textbox__title">
							<HomeSectionTitle text={sectionTitle}/>
						</div>
						<div
							className="col col-xs-12 cash-rebate__textbox__txt"
							dangerouslySetInnerHTML={{__html: txt}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CashRebate;